import React from "react";

const PPVDemo1 = () => {
  return (
    <div className="flex items-center justify-center h-screen p-8 py-36">
      <iframe
        src="https://play.webvideocore.net/popapp.php?l=2506952&w=720&h=800&p=a75pi6a8fk84ss4&title=Demo&bgcolor1=%230c0c0e&bgcolor2=%230c0c0e&hide_playlist=&hide_description=&hide_live_chat=&layout=default&is_inversed=&theme=dark&image=https%3A%2F%2Fmember.streamingvideoprovider.com%2Fpanel%2Fserver%2Fclip%3Fa%3DGenerateThumbnail%26clip_id%3D10100946%26size%3Dlarge%26is_recorded%3D10100946&use_html5=1&live_id=&sel_playlist=495hjb9hh78h48g&sel_multiplaylist=&is_responsive=1&is_vertical=&one_thumb_per_row=1&thumbs_size=medium&disable_hash=1&skinAlpha=50&colorBase=%230c0c0e&colorIcon=%23ffffff&colorHighlight=%23002B5D&fs_popin=&start_volume=50&close_button=&player_align=NONE&player_bar=1&auto_play=1&auto_hide_player_controls=1&chat_position=&description_position=&playlist_position=&allow_fullscreen=1&player_start_volume=50&widget_height_behavior=0&template_published_fields=-1&play_button=1&play_button_style=pulsing&show_auto_play_next=&auto_play_next=&floating_player=none"
        className="w-full h-full"
        title="PPV Stream"
        allowFullScreen
        frameBorder="0"
      ></iframe>
    </div>
  );
};

export default PPVDemo1;
